export default {
  currentUser: {
    userId: '',
    username: '',
    mobile: '',
    name: '',
    locations: ''
  }
}
